import { Loader2 } from "lucide-react"

export interface LoadingPageProps {
  topOffset?: string
  message?: string
}

const LoadingPage = ({ message, topOffset = "200px" }: LoadingPageProps) => {
  return (
    <div
      className="flex items-start justify-center min-h-screen"
      style={{
        paddingTop: topOffset,
      }}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin" />
        <div className="text-lg font-medium">{message}</div>
      </div>
    </div>
  )
}

export default LoadingPage
